import { createEntityAdapter, createSlice, createSelector } from '@reduxjs/toolkit'
import { get, filter } from 'lodash-es'
import ActionTypes from '@constants/action_types.js'

const tablesAdapter = createEntityAdapter()

const tablesSlice = createSlice({
  name: 'tables',
  initialState: tablesAdapter.getInitialState(),
  extraReducers: builder => {
    builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => {
      const { payload } = action
      if (payload.hasOwnProperty('tables')) {
        tablesAdapter.upsertMany(state, payload.tables)
      }
    })
  },
})

// Selectors

export const tablesSelectors = tablesAdapter.getSelectors(state => state.data.tables)

export const getTablesForDatabase = createSelector(
  (state, props) => props.databaseId,
  tablesSelectors.selectAll,
  function (databaseId, allTables) {
    return filter(allTables, table => {
      const tableDatabaseId = get(table, ['attributes', 'database_id'])
      return tableDatabaseId.toString() === databaseId.toString()
    })
  }
)

// selects all tables matching the given array of ids
export const selectTablesByIds = createSelector(
  (state, tableIds) => tableIds,
  tablesSelectors.selectEntities,
  function (tableIds, tablesById) {
    return tableIds.map(tableId => tablesById[tableId])
  }
)

export default tablesSlice.reducer
